import React, { useContext, useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { ThemeContext } from 'styled-components'

// mixins
import { IconWrapper, MessageBullet } from './mixins'

// redux
import { getTotalMensajesSinLeer } from '../../redux/actions/messages'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

interface MessagesProps {
  msjsSinLeer: number
}

const MessagesComponent = ({ msjsSinLeer }: MessagesProps) => {
  const dispatch = useDispatch()
  const { colors } = useContext<{ colors }>(ThemeContext)
  const [numberShown, setNumberShown] = useState<string>('')
  const grey72 = colors.grey72

  useEffect(() => {
    dispatch(getTotalMensajesSinLeer())
  }, [])

  useEffect(() => {
    if (msjsSinLeer) {
      if (msjsSinLeer > 9) {
        setNumberShown('+9')
      } else {
        setNumberShown(msjsSinLeer.toString())
      }
    }
  }, [msjsSinLeer])

  return (
    <IconWrapper color={grey72}>
      <Icon name="icon-light-email" size="24" color={grey72} />
      {!!msjsSinLeer && <MessageBullet>{numberShown}</MessageBullet>}
    </IconWrapper>
  )
}

const states = ({ messagesStore }) => {
  return {
    msjsSinLeer: messagesStore.mensajesNuevos.total,
  }
}

export default connect(states)(MessagesComponent)
